import { StyleSheet } from '@react-pdf/renderer';

const pendingAplicationReportStyles = StyleSheet.create({
  page: { padding: 30, fontSize: 10, paddingBottom: 50 },
  pageHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
    fontSize: 9,
    color: '#555',
  },
  headerCenter: { flex: 1, textAlign: 'center' },
  headerSide: { flex: 1 },
  section: { marginBottom: 12 },
  sectionTitle: { textAlign: 'center', marginBottom: 8, marginTop: 8 },
  infoRow: { flexDirection: 'row', marginBottom: 2 },
  label: { fontFamily: 'Helvetica-Bold' },
  table: { marginTop: 8, marginBottom: 8 },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#000',
    paddingVertical: 4,
    marginBottom: 4,
  },
  colProduto: { flex: 3 },
  colDose: { flex: 2, textAlign: 'right' },
  colTotal: { flex: 2, textAlign: 'right' },
  colSeed: { flex: 3 },
  colSeedDose: { flex: 2, textAlign: 'right' },
  colSeedTotal: { flex: 2, textAlign: 'right' },
  tableHeaderText: { fontFamily: 'Helvetica-Bold' },
  footer: {
    position: 'absolute',
    bottom: 20,
    right: 30,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    fontSize: 9,
    color: '#555',
  },
});

export default pendingAplicationReportStyles;
